document.addEventListener('click', function (event) {
  var opener = event.target.closest('[data-fk-sg-open]');
  if (opener) {
    var d = document.getElementById(opener.getAttribute('data-fk-sg-open'));
    if (d && typeof d.showModal === 'function') d.showModal();
    return;
  }
  var closer = event.target.closest('[data-fk-sg-close]');
  if (closer) {
    var dc = closer.closest('dialog');
    if (dc) dc.close();
    return;
  }
  var dialog = event.target.closest('dialog.fk-sg');
  if (dialog && event.target === dialog) dialog.close();
});
